'use client';

import classNames from '@sindresorhus/class-names';
import {useState} from 'react';

import ChevronDown from '@ui-kit/src/assets/Icons/ChevronDown.svg';
import ChevronUp from '@ui-kit/src/assets/Icons/ChevronUp.svg';

import styles from './Accordion.module.scss';

interface Props {
  title: React.ReactNode;
  children: React.ReactNode;
  isMobileOnly?: boolean;
  isOpenedDefault?: boolean;
  onClick?: () => void;
  iconTestId?: string;
  titleTestId?: string;
}

export const Accordion = ({
  children,
  isMobileOnly,
  title,
  isOpenedDefault = false,
  onClick,
  iconTestId,
  titleTestId,
}: Props) => {
  const [isOpened, setOpened] = useState(isOpenedDefault);

  const handleClick = () => {
    onClick?.();
    setOpened(!isOpened);
  };

  return (
    <div className={styles.accordion}>
      <h3
        className={styles.title}
        onClick={handleClick}
        data-testid={titleTestId}
      >
        {title}
        {isOpened ? (
          <img
            className={classNames({
              [styles.mobileIcons]: isMobileOnly,
            })}
            src={ChevronUp.src}
            data-testid={iconTestId}
            alt="Закрыть список"
            loading="lazy"
            width="24"
            height="24"
          />
        ) : (
          <img
            className={classNames({
              [styles.mobileIcons]: isMobileOnly,
            })}
            src={ChevronDown.src}
            data-testid={iconTestId}
            alt="Раскрыть список"
            loading="lazy"
            width="24"
            height="24"
          />
        )}
      </h3>
      <div
        className={classNames(styles.children, {
          [styles.hiddenMobileOnly]: !isOpened && isMobileOnly,
          [styles.hidden]: !isOpened && !isMobileOnly,
        })}
      >
        {children}
      </div>
    </div>
  );
};
